const config = {
  API_URL: "",
  LOG_REQUESTS: false,
  AMPLIFY: {
    Auth: {
      region: "ap-southeast-2",
      userPoolId: "ap-southeast-2_Lm1udAv0z",
      userPoolWebClientId: "1orv8mv76g9kceut8r13tkusj7",
    },
  },
  VERSION_INFO: "2026.10.05-7ade031",
};

export default config;
